import { render, staticRenderFns } from "./options.compatibility.view.vue?vue&type=template&id=f4a4840c&"
import script from "./options.compatibility.view.vue?vue&type=script&lang=ts&"
export * from "./options.compatibility.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports